import React, { useEffect, useState } from "react";
import SearchIcon from "@mui/icons-material/Search";
import { Link } from "react-router-dom";
import PaginationComponent from "../../../Components/PaginationComponent";
import toast from "react-hot-toast";
import expenseService from "../../../Services/expenseService";
import { IoMdAdd } from "react-icons/io";

const Expense = () => {
  const [searchData, setSearchData] = useState("");
  const [filteredData, setFilteredData] = useState([]);
  const [paginatedData, setPaginatedData] = useState([]);
  const itemsPerPage = 10;
  const [currentPage, setCurrentPage] = useState(1);
  const [patients, setPatients] = useState([]);
  const [loading, setLoading] = useState(false);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");

  useEffect(() => {
    const getPatients = async () => {
      try {
        setLoading(true);
        const response = await expenseService.fetchAll();
        const sortedExpenses = response.expenses.sort(
          (a, b) => new Date(b.expense_date) - new Date(a.expense_date)
        );
        setPatients(sortedExpenses);
      } catch (error) {
        toast.error("Error fetching Expenses");
      } finally {
        setLoading(false);
      }
    };
    getPatients();
  }, []);

  useEffect(() => {
    const filteredResult =
      patients?.filter((item) => {
        const itemDate = new Date(item?.expense_date);
        const isWithinDateRange =
          (!startDate || new Date(startDate) <= itemDate) &&
          (!endDate || itemDate <= new Date(endDate));
        return (
          item?.item_name?.toLowerCase().includes(searchData.toLowerCase()) &&
          isWithinDateRange
        );
      }) || [];
    setFilteredData(filteredResult);
    setCurrentPage(1);
  }, [searchData, startDate, endDate, patients]);

  useEffect(() => {
    const startIndex = (currentPage - 1) * itemsPerPage;
    const endIndex = startIndex + itemsPerPage;
    setPaginatedData(filteredData?.slice(startIndex, endIndex) || []);
  }, [currentPage, filteredData]);

  const formatDate = (dateString) => {
    if (!dateString) return "";
    const options = { year: "numeric", month: "short", day: "numeric" };
    return new Date(dateString).toLocaleDateString("en-US", options);
  };

  const totalAmount = filteredData
    .reduce((sum, item) => sum + parseFloat(item?.amount || 0), 0)
    .toFixed(2);

  return (
    <div className="p-3 sm:p-6">

      <div className="bg-white border border-gray-200 rounded-xl px-4 sm:px-6 py-4 mb-5 shadow-sm">

        <div className="flex items-center justify-between gap-3 flex-wrap">
          <div>
            <h1 className="text-[17px] font-[500] text-gray-800">Manage Expenses</h1>
            <p className="text-[12px] text-gray-400 mt-0.5">
              {filteredData?.length || 0} records found
            </p>
          </div>

          
        </div>

        <div className="flex flex-wrap items-center gap-2 mt-3">
          <input
            type="date"
            value={startDate}
            onChange={(e) => setStartDate(e.target.value)}
            className="text-[13px] bg-gray-50 border border-gray-200 rounded-lg px-3 py-[7px] focus:outline-none text-gray-700 flex-1 min-w-[130px]"
          />
          <input
            type="date"
            value={endDate}
            onChange={(e) => setEndDate(e.target.value)}
            className="text-[13px] bg-gray-50 border border-gray-200 rounded-lg px-3 py-[7px] focus:outline-none text-gray-700 flex-1 min-w-[130px]"
          />
          {(startDate || endDate) && (
            <button
              onClick={() => { setStartDate(""); setEndDate(""); }}
              className="text-[13px] bg-gray-100 hover:bg-gray-200 text-gray-600 px-4 py-[7px] rounded-lg whitespace-nowrap"
            >
              Show All
            </button>
          )}
          <div className="relative flex-1 min-w-[150px]">
            <SearchIcon
              className="absolute left-2.5 top-1/2 -translate-y-1/2 text-gray-400"
              style={{ fontSize: 16 }}
            />
            <input
              type="search"
              placeholder="Search by item..."
              value={searchData}
              onChange={(e) => setSearchData(e.target.value)}
              className="pl-8 pr-3 py-[7px] w-full text-[13px] bg-gray-50 border border-gray-200 rounded-lg focus:outline-none"
            />
          </div>
          <div className="flex items-center gap-2 flex-shrink-0">
            <Link to="AddEditExpenseHead">
              <button className="relative overflow-hidden bg-[#2F6DB4] text-white text-[12px] sm:text-[13px] font-[500] px-3 sm:px-4 py-2 rounded-lg border border-gray-300 shadow-md hover:shadow-gray-200 hover:scale-[1.03] active:scale-[0.97] transition-all duration-300 before:absolute before:inset-0 before:-translate-x-full hover:before:translate-x-full before:bg-white/20 before:transition-transform before:duration-500 whitespace-nowrap">
                <IoMdAdd className="inline mb-0.5" size={16} />Expense Head
              </button>
            </Link>
            <Link to="AddEditExpense">
              <button className="relative overflow-hidden bg-[#2F6DB4] text-white text-[12px] sm:text-[13px] font-[500] px-3 sm:px-4 py-2 rounded-lg border border-gray-300 shadow-md hover:shadow-gray-200 hover:scale-[1.03] active:scale-[0.97] transition-all duration-300 before:absolute before:inset-0 before:-translate-x-full hover:before:translate-x-full before:bg-white/20 before:transition-transform before:duration-500 whitespace-nowrap">
                <IoMdAdd className="inline mb-0.5" size={16} /> New Expense
              </button>
            </Link>
          </div>
        </div>
      </div>

      <div className="hidden sm:block bg-white border border-gray-200 rounded-xl overflow-hidden shadow-sm">
        <table className="w-full">
          <thead>
            <tr className="bg-[#2F6DB4] text-[11px] uppercase text-white">
              <th className="py-3 px-4 text-left">Date</th>
              <th className="py-3 px-4 text-left">Item Name</th>
              <th className="py-3 px-4 text-left">Amount</th>
              <th className="py-3 px-4 text-left">Details</th>
              <th className="py-3 px-4 text-left">Expense Account</th>
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr>
                <td colSpan={5} className="py-10 text-center text-gray-400 text-[13px]">
                  Loading...
                </td>
              </tr>
            ) : paginatedData?.length === 0 ? (
              <tr>
                <td colSpan={5} className="py-10 text-center text-gray-400 text-[13px]">
                  No records found
                </td>
              </tr>
            ) : (
              <>
                {paginatedData?.map((patient, index) => (
                  <tr
                    key={patient?.expense_id || index}
                    className={`border-t text-[13px] hover:bg-gray-50 ${
                      index % 2 === 0 ? "bg-gray-50" : "bg-white"
                    }`}
                  >
                    <td className="py-3 px-4 font-[500] text-gray-800">
                      {formatDate(patient?.expense_date)}
                    </td>
                    <td className="py-3 px-4 text-gray-600">{patient?.item_name}</td>
                    <td className="py-3 px-4 font-semibold text-gray-800">
                      {parseFloat(patient?.amount || 0).toFixed(2)}
                    </td>
                    <td className="py-3 px-4 text-gray-500">
                      {patient?.description || "-"}
                    </td>
                    <td className="py-3 px-4 text-gray-600">
                      {patient?.expensehead_title || "-"}
                    </td>
                  </tr>
                ))}
                <tr className="bg-[#2F6DB4] text-white text-[13px] font-semibold">
                  <td className="py-3 px-4" colSpan={2}>Total</td>
                  <td className="py-3 px-4">{totalAmount}</td>
                  <td colSpan={2}></td>
                </tr>
              </>
            )}
          </tbody>
        </table>
      </div>

      <div className="sm:hidden flex flex-col gap-3">
        {loading ? (
          <div className="py-10 text-center text-gray-400 text-[13px]">Loading...</div>
        ) : paginatedData?.length === 0 ? (
          <div className="py-10 text-center text-gray-400 text-[13px]">No records found</div>
        ) : (
          <>
            {paginatedData?.map((patient, index) => (
              <div
                key={patient?.expense_id || index}
                className="bg-white border border-gray-200 rounded-xl overflow-hidden shadow-sm"
              >
                <div className="bg-[#2F6DB4] px-4 py-2 flex items-center justify-between">
                  <span className="text-white text-[13px] font-medium">
                    {formatDate(patient?.expense_date)}
                  </span>
                  {patient?.expensehead_title && (
                    <span className="text-blue-100 text-[11px] bg-white/20 px-2 py-0.5 rounded-full">
                      {patient.expensehead_title}
                    </span>
                  )}
                </div>

                <div className="px-4 py-3 flex flex-col gap-2">
                  <div className="flex items-center justify-between">
                    <span className="text-[13px] font-medium text-gray-800">
                      {patient?.item_name}
                    </span>
                    <span className="text-[14px] font-semibold text-[#2F6DB4]">
                      {parseFloat(patient?.amount || 0).toFixed(2)}
                    </span>
                  </div>
                  {patient?.description && (
                    <p className="text-[12px] text-gray-400">{patient.description}</p>
                  )}
                </div>
              </div>
            ))}

            <div className="bg-[#2F6DB4] text-white rounded-xl px-4 py-3 flex justify-between items-center">
              <span className="text-[12px] uppercase font-medium tracking-wide">Total</span>
              <span className="text-[15px] font-bold">{totalAmount}</span>
            </div>
          </>
        )}
      </div>

      <PaginationComponent
        filteredData={filteredData}
        setPaginatedData={setPaginatedData}
        itemsPerPage={itemsPerPage}
        currentPage={currentPage}
        setCurrentPage={setCurrentPage}
      />
    </div>
  );
};

export default Expense;